import { render, staticRenderFns } from "./ucenter_smrz.vue?vue&type=template&id=17282e81"
import script from "./ucenter_smrz.vue?vue&type=script&lang=js"
export * from "./ucenter_smrz.vue?vue&type=script&lang=js"
import style0 from "./ucenter_smrz.vue?vue&type=style&index=0&id=17282e81&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports